import "@ant-design/v5-patch-for-react-19";
// import Keycloak from 'keycloak-js';
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import store from "./app/app.store.ts";
// import {
//   KEYCLOAK_CLIENT,
//   KEYCLOAK_REALM,
//   KEYCLOAK_URL,
// } from './config/global.config.ts';
import "./styles/antd.css";
import "./styles/index.css";

// export const keycloak = new Keycloak({
//   url: KEYCLOAK_URL,
//   realm: KEYCLOAK_REALM,
//   clientId: KEYCLOAK_CLIENT,
// });

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  // <ReactKeycloakProvider
  //   authClient={keycloak}
  //   initOptions={{
  //     onLoad: 'check-sso',
  //     silentCheckSsoRedirectUri:
  //       window.location.origin + '/silent-check-sso.html',
  //     pkceMethod: 'S256',
  //     checkLoginIframe: false,
  //   }}
  //   // onEvent={(event, error) => {
  //   //   console.log(error);
  //   // }}
  //   LoadingComponent={<Loader />}
  // >
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
  // </ReactKeycloakProvider>,
  // </StrictMode>,
);
